import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "27.73",
  height: "57.537",
  viewBox: "0 0 27.73 57.537"
}
const _hoisted_2 = { transform: "translate(1.008 1)" }
const _hoisted_3 = { transform: "translate(0 0)" }
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["stroke"]
const _hoisted_6 = { transform: "translate(8.446 40.157)" }
const _hoisted_7 = ["stroke"]
const _hoisted_8 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  __name: 'IconPower1',
  props: {
  color: {
    type: String,
    default: '#D4D4D4',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("g", _hoisted_3, [
        _createElementVNode("path", {
          d: "M45.94,190.169c0,3.122-2.2,6.013-4.92,6.013s-4.92-2.891-4.92-6.013a4.933,4.933,0,1,1,9.84,0Z",
          transform: "translate(-28.196 -184.878)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_4),
        _createElementVNode("path", {
          d: "M39.121,217.665l4.744,14.012a1.714,1.714,0,0,1-1.071,2.166l-.041.014a1.751,1.751,0,0,1-2.195-1.061l-3.811-10.642-.022-.009,2.23,18.455a1.111,1.111,0,0,1-1.128,1.272H24.439a1.111,1.111,0,0,1-1.128-1.272l2.231-18.455-.026.009L21.706,232.8a1.751,1.751,0,0,1-2.195,1.061l-.041-.014a1.714,1.714,0,0,1-1.071-2.166l4.744-14.012-1,2.963,1.177-3.431a3.206,3.206,0,0,1,2.829-2.02h9.971a3.206,3.206,0,0,1,2.829,2.02l1.177,3.431",
          transform: "translate(-18.309 -201.715)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_5),
        _createElementVNode("g", _hoisted_6, [
          _createElementVNode("path", {
            d: "M41.7,275.263v13.243a2.142,2.142,0,0,1-2.136,2.136h-.107a2.142,2.142,0,0,1-2.136-2.136V275.263",
            transform: "translate(-37.318 -275.263)",
            fill: "none",
            stroke: __props.color,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, 8, _hoisted_7),
          _createElementVNode("path", {
            d: "M51.552,275.263v13.243a2.142,2.142,0,0,1-2.136,2.136H49.31a2.142,2.142,0,0,1-2.136-2.136V275.263",
            transform: "translate(-42.795 -275.263)",
            fill: "none",
            stroke: __props.color,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, 8, _hoisted_8)
        ])
      ])
    ])
  ]))
}
}

})